import classNames from "classnames";
import { withTranslation } from "next-i18next";
import { usePagination, useSearchBox } from "react-instantsearch";
import CatalogSearchBadge from "./CatalogSearchBadge";

function CatalogSearchResults({ getInitializedUiState, updatePersonalisedFilters, t }) {
  const { nbHits } = usePagination();
  const { query } = useSearchBox();

  return (
    <div
      className={classNames(
        "d-flex align-items-center pb-2",
        query ? "justify-content-between" : "justify-content-center",
      )}
    >
      <CatalogSearchBadge
        getInitializedUiState={getInitializedUiState}
        updatePersonalisedFilters={updatePersonalisedFilters}
      />

      {nbHits > 0 && (
        <p className="mt-1 mb-2 ms-2 text-gray font-size-sm">
          {t("catalog:filters.results", { count: nbHits })}
        </p>
      )}
    </div>
  );
}

export default withTranslation("catalog")(CatalogSearchResults);
